export enum EDiscoverCardState {
  New = 'new',
  ComingSoon = 'coming_soon',
  IsTimer = 'is_timer'
}

export enum EDiscoverFilter {
  ForYou = 'for-you',
  New = 'new',
  ComingSoon = 'coming-soon',
  SFW = 'sfw',
  NSFW = 'nsfw',
  Tattoos = 'tattoos',
  Piercings = 'piercings',
  Blondes = 'blondes',
  Brunettes = 'brunettes'
}
